import { delegate } from "@otto-ec/global-resources/event";
import { type DataTrLifeCycleEventMap, unlockInit as unlockTrackingInit } from "@otto-ec/global-resources/tracking";
import type { DataContainer, Feature } from "@otto-ec/tracking-bct";
import { getClosestParentByDataAttribute, removeQuoteEncoding, addFeatureOrder } from "../utils";

const addNextPITrackingLabels = (ev: DataTrLifeCycleEventMap["tr-submit-tracking"]) => {
	const target = ev.target as HTMLElement;
	const attribute = "next-pi-tracking-labels";

	const piLabelContainer = getClosestParentByDataAttribute(target, attribute);
	if (!piLabelContainer) return;
	const piLabel = piLabelContainer.getAttribute(`data-${attribute}`)!;
	const parsedPILabels = JSON.parse(removeQuoteEncoding(piLabel));

	if (ev.detail.method === "submitMove") {
		const features = ev.detail.parameterMap.action?.features;
		addLabelsToFeatures(parsedPILabels, features);
	}
};

const addFeatureTrackingLabels = (ev: DataTrLifeCycleEventMap["tr-submit-tracking"]) => {
	const target = ev.target as HTMLElement;
	const attribute = "feature-tracking-labels";

	const featureLabelContainer = getClosestParentByDataAttribute(target, attribute);
	if (!featureLabelContainer) return;
	const featureLabels = featureLabelContainer.getAttribute(`data-${attribute}`)!;
	const parsedFeatureLabels = JSON.parse(removeQuoteEncoding(featureLabels));

	if (ev.detail.method === "submitMove") {
		const features = ev.detail.parameterMap.action?.features;
		addLabelsToFeatures(parsedFeatureLabels, features);
	}
	if (ev.detail.method === "submitMerge") {
		const features = ev.detail.parameterMap.features;
		addLabelsToFeatures(parsedFeatureLabels, features);
	}
	if (ev.detail.method === "submitEvent") {
		const features = ev.detail.parameterMap.action?.features;
		addLabelsToFeatures(parsedFeatureLabels, features);
	}
};

const addLabelsToFeatures = (featureLabels: DataContainer, features?: Feature[]) => {
	if (!features?.length) return;

	const labels = features[0]!.labels;
	features[0]!.labels = { ...labels, ...featureLabels };
};

const addFT3TrackingInformation = (ev: DataTrLifeCycleEventMap["tr-submit-tracking"]) => {
	addNextPITrackingLabels(ev);
	addFeatureTrackingLabels(ev);
};

delegate(window.document, "tr-submit-tracking", ".ft9_product-highlight__container", addFeatureOrder);

/*                                                                                                                                                                                                      */
delegate(window.document, "tr-submit-tracking", ".ft9_product-highlight__container", addFT3TrackingInformation);
unlockTrackingInit("ft9.daily_deal.lock.token");
